<footer class="w-full" [class]="{'hidden': hideElement}" #footerContainer>
    
    <!-- FOOTER MOBILE WRAPPER -->
    <div class="md:hidden flex z-10 gap-x-2 relative">
        
        <!-- BENEFITS BUTTON -->
        <div 
            class="absolute bottom-[calc(100%+(var(--spacing)*4.5))] left-0 pointer-events-auto transition-all"
            [class]="view() === AppViews.Topview ? 'translate-y-0' : '-translate-y-[55px]'"
        >

            <app-benefits-button />
            
        </div>

        <!-- SEARCH & MENU BUTTONS -->
        <div 
            class="flex z-10 gap-x-2 w-full min-h-[34px]"
            [class]="view() === AppViews.Topview ? 'pointer-events-auto' : 'pointer-events-none'"
        >
            <app-search/>
    
            <app-menu-buttons class="grow overflow-hidden"/>
        </div>

        <!-- MINIMAP & RELATED PREVIEWS -->
        @if(isMobile()){
            <div
                [class]="view() === AppViews.Pano ? 'pointer-events-auto' : 'pointer-events-none'" 
                class="absolute left-0 bottom-0 flex gap-x-2 w-screen"
            >
               
                <app-minimap/>
    
                <div class="overflow-x-auto whitespace-nowrap no-scrollbar">
                    <app-related-previews/>
                </div>
    
            </div>
        }

    </div>

    <!-- FOOTER DESKTOP WRAPPER -->
    <div class="hidden md:flex justify-between items-center min-h-12">

        <!-- MINIMAP || PREVIEWS -->
        <div class="w-1/3 flex self-end relative">

            <!-- WRAPPER -->
            <div class="absolute z-10 bottom-0 ">
                <div class="my-4">
                    <app-disclaimer />
                </div>
                
                <div class="flex gap-x-2">
                    
                    @if(!isMobile()){
                        <app-minimap />
                    }

                    <app-related-previews />

                </div>
            </div>

        </div>

        <!-- LOGO -->
        <div class="w-1/3 flex justify-center pointer-events-auto">

            <app-logo />

        </div>

        <!-- ACTION BUTTONS  -->
        <div class="w-1/3">

            <app-link-action-buttons />

        </div>

    </div>

</footer>